import { InputRightElement } from '@chakra-ui/react';
import { Button, Icon } from '@mercator-gcp/grout';

type HideShowPasswordProps = {
  isPasswordVisible: boolean;
  onClick: () => void;
};

const styles = {
  inputGroupButton: {
    mr: 'padding_8',
  },
};

const HideShowPasswordButton = ({
  isPasswordVisible,
  onClick,
}: HideShowPasswordProps) => {
  return (
    <InputRightElement>
      <Button variant="unstyled" sx={styles.inputGroupButton} onClick={onClick}>
        {isPasswordVisible ? (
          <Icon name={Icon.Name.EyeHide} />
        ) : (
          <Icon name={Icon.Name.Eye} />
        )}
      </Button>
    </InputRightElement>
  );
};

export default HideShowPasswordButton;
